import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import BackgroundIcon from '../components/common/IconContainer/BackgroundIcon';
import { getIconPageParams } from '../components/common/IconContainer/params';
import { usePage } from '../hooks/usePage';
import { useContentfulSelector } from '../redux/hooks';
import { selectPagesStatus } from '../redux/selectors';
import { renderComponent } from '../utils/renderComponent';
import PageBuilderProvider from './pageBuilderProvider';
import { PageContainer } from './styles';
const PageBuilder = ({ components, additionalFields, }) => {
    var _a, _b;
    const loading = useContentfulSelector(selectPagesStatus);
    const { data } = usePage();
    const params = useMemo(() => { var _a; return getIconPageParams((_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.handle); }, [(_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.handle]);
    if (!(components === null || components === void 0 ? void 0 : components.length))
        return null;
    return (_jsxs(PageContainer, { "$loading": loading, children: [React.Children.toArray((_b = params === null || params === void 0 ? void 0 : params.icons) === null || _b === void 0 ? void 0 : _b.map((iconParams, i) => (_jsx(BackgroundIcon, { iconParams: iconParams }, `icon-${i}-${iconParams.side}`)))), React.Children.toArray(components === null || components === void 0 ? void 0 : components.map((component) => renderComponent(component, false, additionalFields)))] }));
};
const PageBuilderWithProvider = ({ components, additionalFields, handlePaymentPage, }) => {
    return (_jsx(PageBuilderProvider, { handlePaymentPage: handlePaymentPage, children: _jsx(PageBuilder, { components: components, additionalFields: additionalFields }) }));
};
export default PageBuilderWithProvider;
